"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var qrcode_react_1 = require("qrcode.react");
var react_1 = require("react");
var context_1 = require("../../context/context");
var styles_1 = require("../../styles");
var Button_1 = __importDefault(require("./Button"));
var FaApple_1 = require("@react-icons/all-files/fa/FaApple");
var FaGooglePlay_1 = require("@react-icons/all-files/fa/FaGooglePlay");
var styled_components_1 = require("styled-components");
var mobile = 700;
var icon = "https://services-healthpage.orbs.network/img/odnp-logo.png";
function Odnp(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var account = (0, context_1.useTwapContext)().account;
    var _c = (0, react_1.useState)(false), open = _c[0], setOpen = _c[1];
    var translations = (0, context_1.useTwapContext)().translations;
    if (!account)
        return null;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledButton, __assign({ onClick: function () { return setOpen(true); }, className: "twap-odnp-button" }, { children: (0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ className: "twap-odnp-button-children" }, { children: [(0, jsx_runtime_1.jsx)("img", { src: icon }), (0, jsx_runtime_1.jsx)(styles_1.StyledOneLineText, { children: translations.notify })] })) })), (0, jsx_runtime_1.jsxs)(StyledOdnp, __assign({ className: "twap-odnp ".concat(className) }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledColumnFlex, __assign({ gap: 20, style: { alignItems: "center" }, className: "twap-odnp-header" }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: "twap-odnp-title" }, { children: "Get free mobile alerts for on-chain events" })), (0, jsx_runtime_1.jsx)(styles_1.StyledText, __assign({ className: "twap-odnp-subtitle" }, { children: "Get a push notification or even a phone call to make sure you never lose your funds and you're always up to date" }))] })), (0, jsx_runtime_1.jsx)(styles_1.StyledColumnFlex, __assign({ gap: 30, style: { alignItems: "center" } }, { children: (0, jsx_runtime_1.jsxs)(StyledFlex, __assign({ className: "twap-odnp-sections" }, { children: [(0, jsx_runtime_1.jsx)(LeftSection, {}), (0, jsx_runtime_1.jsx)(StyledSeparator, { className: "twap-odnp-separator" }), (0, jsx_runtime_1.jsx)(RightSection, {})] })) }))] }))] }));
}
var Link = function (_a) {
    var Icon = _a.Icon, name = _a.name, url = _a.url;
    return ((0, jsx_runtime_1.jsx)(StyledLink, __assign({ href: url, target: "_blank", className: "twap-button twap-odnp-link" }, { children: (0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, { children: [(0, jsx_runtime_1.jsx)(Icon, { style: { width: 20, height: 25 } }), (0, jsx_runtime_1.jsxs)("p", { children: ["Download on ", name] })] }) })));
};
var StyledLink = (0, styled_components_1.styled)("a")((_a = {
        width: "90%",
        textDecoration: "unset!important",
        height: "auto",
        padding: "10px 10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: {
            fontWeight: "600!important",
            fontSize: 14,
            color: "inherit",
        }
    },
    _a["@media(max-width: ".concat(mobile, "px)")] = {
        padding: "5px 10px",
    },
    _a));
var LeftSection = function () {
    return ((0, jsx_runtime_1.jsxs)(StyledLeft, __assign({ title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Download the mobile app ", (0, jsx_runtime_1.jsx)("br", {}), " \"DeFi Notifications\""] }), step: 1 }, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledColumnFlex, __assign({ style: { alignItems: "center" } }, { children: (0, jsx_runtime_1.jsx)("img", { className: "twap-odnp-left-logo", src: icon }) })), (0, jsx_runtime_1.jsxs)(styles_1.StyledColumnFlex, __assign({ style: { alignItems: "center" }, className: "twap-odnp-left-buttons" }, { children: [(0, jsx_runtime_1.jsx)(Link, { name: "Apple", Icon: FaApple_1.FaApple, url: "https://apps.apple.com/us/app/defi-notifications/id1588243632" }), (0, jsx_runtime_1.jsx)(Link, { name: "Android", Icon: FaGooglePlay_1.FaGooglePlay, url: "https://play.google.com/store/apps/details?id=com.orbs.openDefiNotificationsApp" })] }))] })));
};
var StyledCloseButton = (0, styled_components_1.styled)(Button_1.default)({
    width: "100%",
});
var RightSection = function () {
    return ((0, jsx_runtime_1.jsx)(StyledRight, __assign({ title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Open the \u201CDeFi Notifications\u201D ", (0, jsx_runtime_1.jsx)("br", {}), " mobile app"] }), step: 2, className: "twap-odnp-section-right" }, { children: (0, jsx_runtime_1.jsxs)(styles_1.StyledColumnFlex, __assign({ style: { alignItems: "center" }, className: "twap-odnp-section-right-flex", gap: 20 }, { children: [(0, jsx_runtime_1.jsx)(QR, {}), (0, jsx_runtime_1.jsx)("p", __assign({ className: "twap-odnp-section-right-bottom-text" }, { children: "and Scan the QR Code to select what to monitor" }))] })) })));
};
var Section = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, step = _a.step;
    return ((0, jsx_runtime_1.jsxs)(StyledSection, __assign({ className: "twap-odnp-section ".concat(className) }, { children: [(0, jsx_runtime_1.jsx)("figure", __assign({ className: "twap-odnp-section-step" }, { children: step })), (0, jsx_runtime_1.jsxs)(styles_1.StyledColumnFlex, __assign({ gap: 20, className: "twap-odnp-section-content" }, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledText, __assign({ className: "twap-odnp-section-title" }, { children: title })), children] }))] })));
};
var StyledLeft = (0, styled_components_1.styled)(Section)({
    ".twap-odnp-left-logo": {
        width: 70,
        height: 70,
    },
});
var StyledRight = (0, styled_components_1.styled)(Section)((_b = {
        ".twap-odnp-section-right-bottom-text": {
            fontSize: 15,
            fontWeight: 400,
            maxWidth: 200,
        }
    },
    _b["@media(max-width: ".concat(mobile, "px)")] = {
        display: "none",
    },
    _b));
var StyledSeparator = (0, styled_components_1.styled)("div")({
    background: "white",
    width: 1,
    opacity: 0.7,
});
var StyledSection = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)((_c = {
        justifyContent: "space-between",
        gap: 20,
        ".twap-odnp-section-step": {
            fontWeight: 600,
            fontSize: 20,
            padding: 0,
            margin: 0,
        },
        ".twap-odnp-section-content": {
            justifyContent: "space-between",
            flex: 1,
            alignItems: "center",
        },
        ".twap-odnp-section-title": {
            fontSize: 17,
            fontWeight: 600,
        },
        width: "50%",
        alignItems: "center"
    },
    _c["@media(max-width: ".concat(mobile, "px)")] = {
        width: "100%",
        ".twap-odnp-section-step": {
            display: "none",
        },
    },
    _c));
var StyledFlex = (0, styled_components_1.styled)(styles_1.StyledRowFlex)((_d = {
        alignItems: "stretch",
        marginTop: 50,
        gap: 20
    },
    _d["@media(max-width: ".concat(mobile, "px)")] = {
        flexDirection: "column",
        alignItems: "center",
    },
    _d));
var StyledButton = (0, styled_components_1.styled)("button")((_e = {
        padding: "4px 15px",
        cursor: "pointer",
        "& img": {
            width: 22,
            height: 22,
        },
        "& p": {
            fontSize: 14,
            fontWeight: "inherit",
        }
    },
    _e["@media(max-width: ".concat(mobile, "px)")] = {
        "& p": {
            fontSize: 12,
        },
    },
    _e));
var StyledOdnp = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)((_f = {
        textAlign: "center",
        gap: 0,
        ".twap-odnp-title": {
            fontSize: 26,
            lineHeight: "32px",
            textAlign: "center",
            fontWeight: 600,
        },
        ".twap-odnp-subtitle": {
            fontSize: 17,
            lineHeight: "24px",
            fontWeight: 400,
            maxWidth: "90%",
        }
    },
    _f["@media(max-width: ".concat(mobile, "px)")] = {
        ".twap-odnp-title": {
            fontSize: 20,
            lineHeight: "26px",
        },
        ".twap-odnp-subtitle": {
            maxWidth: "unset",
        },
    },
    _f));
var QR = function () {
    var _a = (0, context_1.useTwapContext)(), qrSize = _a.uiPreferences.qrSize, account = _a.account;
    if (!account)
        return null;
    return ((0, jsx_runtime_1.jsx)(qrcode_react_1.QRCodeSVG, { className: "twap-odnp-qr-code", value: "http://onelink.to/9cqqbe" + "?opendefiqr=" + account + "project:" + "twap" + ";", size: qrSize || 180, bgColor: "#ffffff", fgColor: "#000000", level: "M", includeMargin: false }));
};
exports.default = Odnp;
